import Vue from 'vue';

// Register ONLY the BootstrapVue pieces we actually use, imported from their
// individual ESM module paths so webpack bundles just those — not the full
// ~80-component, 1.5 MB BootstrapVue plugin, and NOT IconsPlugin (which
// registers ~1300 icon components; we use `<b-icon>` zero times).
//
// Usage in the app: <b-button>, <b-modal>, <b-tooltip>, v-b-tooltip.
//   - ButtonPlugin  -> b-button
//   - ModalPlugin   -> b-modal (+ v-b-modal directive, $bvModal)
//   - TooltipPlugin -> b-tooltip component + v-b-tooltip directive
// If a new b-* component/directive is needed, add its plugin here.
import { ButtonPlugin } from 'bootstrap-vue/esm/components/button';
import { ModalPlugin } from 'bootstrap-vue/esm/components/modal';
import { TooltipPlugin } from 'bootstrap-vue/esm/components/tooltip';

Vue.use(ButtonPlugin);
Vue.use(ModalPlugin);
Vue.use(TooltipPlugin);
